import { CouponsComponent } from "src/app/views/coupons/coupons.component";
import { categoryAdd, Fee, Item, OrderUser } from "../Interfaces/pedido";
import { Produto } from "../Interfaces/produtos";
import { paymentForm } from "../Interfaces/order";
import { sub } from "date-fns";

// export class PedidoObject implements OrderUser {
//     id_companyFK: string;
//     id_customerFK: string;
//     document_customer: string;
//     orderType: number;
//     orderPrice: number;
//     changeFor: string;
//     orderStatus: string;
//     deliveryFee: number;
//     orderObservation: string;
//     paymentForm: paymentForm[];
//     id_address: string;
//     onlinePay: number;
//     products: Item[];
//     couponType: number;
//     id_coupon: string;
//     coupons: boolean;
//     discountValue: number;

//     constructor(
//       id_companyFK: string,
//       id_customerFK: string,
//       document_customer: string,
//       orderType: number,
//       orderPrice: number,
//       changeFor: string,
//       orderStatus: string,
//       deliveryFee: number,
//       orderObservation: string,
//       paymentForm: paymentForm[],
//       id_address: string,
//       onlinePay: number,
//       products: Item[],
//       couponType: number,
//       id_coupon: string,
//       coupons: boolean,
//       discountValue: number,
//     ){
//       this.id_companyFK = id_companyFK;
//       this.id_customerFK = id_customerFK;
//       this.document_customer = document_customer;
//       this.orderType = orderType;
//       this.orderPrice = orderPrice;
//       this.changeFor = changeFor;
//       this.orderStatus = orderStatus
//       this.deliveryFee = deliveryFee;
//       this.orderObservation = orderObservation;
//       this.paymentForm = paymentForm;
//       this.id_address = id_address;
//       this.onlinePay = onlinePay;
//       this.products = products;
//       this.couponType = couponType;
//       this.id_coupon = id_coupon;
//       this.coupons = coupons;
//       this.discountValue = discountValue;
//     }
// }

export class PedidoObject {
  constructor(init?: Partial<PedidoObject>) {
    Object.assign(this, init);
  }

  id_companyFK: string = '';
  id_customerFK: string = '';
  document_customer: string = '';
  orderType: number = 0;
  orderPrice: number = 0;
  changeFor: string = '0';
  orderStatus: string = '1';
  deliveryFee: number = 0;
  orderObservation: string = '';
  paymentForm: paymentForm[] = [];
  id_address: string = '';
  onlinePay: number = 0;
  products: Item[] = [];
  couponType: number = 0;
  id_coupon: string = '0';
  coupons: boolean = false;
  discountValue: number = 0;
  subTotal: number = 0;
  fee?: Fee;
  localization: string = '';
  scheduled: boolean = false;
  typeScheduled: number = 0; //1 - Padrão | 2 - Agendado
  times?: any;

  //Calcula o total do pedido
  calcTotalOrder(){
    let total = 0;
    let subTotal = 0;

    //Soma os produtos do pedido
    this.products.forEach(product => {
      if(product.discount){
        subTotal += Number(product.totalPrice) + Number(product.discountValue);
      }
      else{
        subTotal += Number(product.totalPrice);
      }
    });

    this.subTotal = Number(subTotal.toFixed(2));

    total = subTotal;

    //Soma a taxa de entrega
    if(this.deliveryFee != 0){
      total += this.deliveryFee
    }

    //Calcula a soma com as taxas ou desconto
    if(this.fee){
      if(this.fee.type == 1){
        // desconto
        total -= Number(this.fee.valueFee);
      }
      else{      
        // acrescimo
        total += Number(this.fee.valueFee);
      }
    }

    //Se o pedido estiver Cupom
    if(this.discountValue != 0){
      if(this.couponType != 3){
        total -= Number(this.discountValue);
      }
    }
  
    //Se o total for menor que 0
    if(total < 0){
      total = 0
    }

    this.orderPrice = Number(total.toFixed(2));

    return total
  }
}

//Classe responsavel por Montar o Objeto do item
export class ItemObject implements Item {

  name!: string;
  id_product!: number;
  quantity!: number;
  unitPrice!: number;
  totalPrice!: number;
  imagem_prod!: string;
  observations!: string;
  categories!: categoryAdd[]
  categoriesEdit!: categoryAdd[];
  pizzaPrice?: number;
  baseValue: number;
  valueTotal!: number;
  flavorsValue!: number;
  pizza!: number;
  baseFlavorsValue: number;
  discount!: boolean;
  discountValue!: number;
  oldPrice!: number

  constructor(
    produto: Produto,
    quantidade: number,
    observation: string,
    adicionais: categoryAdd[],
    baseValue: number,
    totalValue: number,
    pizzaPrice: number,
    flavorsValue: number,
    baseFlavorsValue: number
  ) {

    totalValue = Number(totalValue);

    totalValue = Number(totalValue.toFixed(2));
    baseValue = Number(baseValue.toFixed(2));

    this.name = produto.name;
    this.id_product = produto.id_product;
    this.quantity = quantidade;

    if(produto.pizza == 1){
      this.unitPrice = Number(totalValue / quantidade);
    }
    else{
      this.unitPrice = produto.price;
    }

    this.totalPrice = totalValue
    this.imagem_prod = produto.image_prod;
    this.pizzaPrice = pizzaPrice;
    this.observations = observation;
    this.categories = adicionais
    this.baseValue = baseValue;
    this.flavorsValue = flavorsValue;
    this.pizza = produto.pizza;
    this.baseFlavorsValue = baseFlavorsValue;
    this.discount = false;
    this.discountValue = 0;
    this.oldPrice = 0;
  }
}